import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';
import * as rootReducer from './reducers';

const createRootReducer = ( history ) => combineReducers( {
    form: formReducer,
    router: connectRouter( history ),
    ...rootReducer,
} );

export default createRootReducer;
